"use strict";

exports.__esModule = true;
exports.default = void 0;

var _pallette = _interopRequireDefault(require("./pallette"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Styled-components theme for Reassure-UI icon components
 */
const {
  darkBlue,
  midRed,
  // midGreen,
  white
} = _pallette.default;
var _default = {
  colors: {
    circleIcon: {
      background: darkBlue,
      border: darkBlue,
      error: {
        background: midRed,
        border: midRed
      }
    },
    colourIcon: {
      primary: '#4CAA50',
      secondary: white
    }
  }
};
exports.default = _default;